import React from "react";
import Navbar from "@/components/Navbar";
import AnnouncementBar from "@/components/AnnouncementBar";
import Hero from "@/components/Hero";
import About from "@/components/About";
import Departments from "@/components/Departments";
import WeekendSpecials from "@/components/WeekendSpecials";
import RestaurantMenu from "@/components/RestaurantMenu";
import Gallery from "@/components/Gallery";
import Reviews from "@/components/Reviews";
import FAQ from "@/components/FAQ";
import Catering from "@/components/Catering";
import VisitContact from "@/components/VisitContact";
import Footer from "@/components/Footer";
import ScrollToTop from "@/components/ScrollToTop";

export default function HomePage() {
  return (
    <main data-testid="home-page" className="bg-[#F9F6F0] text-[#232321]">
      <AnnouncementBar />
      <Navbar />
      <Hero />
      <About />
      <Departments />
      <WeekendSpecials />
      <RestaurantMenu />
      <Gallery />
      <Reviews />
      <FAQ />
      <Catering />
      <VisitContact />
      <Footer />
      <ScrollToTop />
    </main>
  );
}
